export const PreQualifierAssetTypeSelectionViewStyles = {
  paragraph: 'text-20px text-black mt-6 sm:text-24px sm:font-semibold',
  bottomContainer: 'w-full flex flex-row-reverse justify-center',
  submitButton: 'w-96 flex justify-center',
  submitButtonContainer: 'text-xl sm:text-2xl',
}
